/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-04 18:41:01
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-04 17:05:12
 * @FilePath: /unifyxp-v2-store-portal/src/router/index.tsx
 */
import React, { useMemo } from 'react';
import { Router } from './Components/Route';
import { useListeners } from 'src/tools/listener';

import MainLayoutRoute from './MainPageRoutes';
import LoginLayout from './LoginRoutes';
import SalesChannelVersion from './SalesChannelVersionRoutes';
import SalesChannelEditor from './SalesChannelEditorRoutes';
import SalesChannelProducts from './SalesChannelProductsRoutes';
import CustomerDatabase from './CustomerDatabaseRoutes';
//import { useClearSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';

import history from './history';
import Routers from './Router';

const AppRouter = () => {
  // useClearSalesChannel();
  //console.log('clear');
  useListeners();
  const routes = [
    SalesChannelVersion,
    SalesChannelEditor,
    SalesChannelProducts,
    CustomerDatabase,
    MainLayoutRoute,
    LoginLayout,
  ];
  const routerGenerator = useMemo(() => {
    return <Routers routes={routes} />;
  }, [routes]);

  return <Router history={history}>{routerGenerator}</Router>;
};
export default AppRouter;
